import { defineStore } from 'pinia';
import { STORE, PROFILETYPE_FILTER } from '../../js/util';
import api from '../../api';
// import sakura from '../../components/sakura/index.js';

export const useNetworksStore = defineStore('networks', {
  state: () => ({
    initNetwork: [],
    portList: [],
    templateList: [],
    vlanList: [],
    vlanInfoList: [], // VLAN ID info
    neighborList: [],
    autoLagList: [],
    switchConfigManualTrunk: {},
    loadingPortList: false,
    switchPtpCfg: {},
    switchPtpCfgUpdated: false,
    autoMode: false,
    autoModeUpdated: false,
  }),

  getters: {
    // ...STORE.getters()
  },

  actions: {
    queryNetworksList(params) {
      return api.networks
        .queryNetworksList(params)
        .then((data) => {
          if (data && data.resp && data.resp.respCode === 0) {
            this.setProfileList(data.profileList)
          } else {
            // sakura.sakuraMessage(data?.resp?.respCode);
          }
          return data
        })
        .catch((error) => {
          throw error
        })
    },
    setProfileList(data) {
      const arr = data.flatMap((item) =>
        item.vlans.map((obj) => ({ ...obj, profileType: item.profileType })),
      )
      this.vlanList = data
      this.vlanInfoList = arr
    },
    setNeighborList(data) {
      this.neighborList = data
      if (this.portList?.length) {
        this.portList = this.portList.map(item => {
          const neighbor = data.find(n => n.portNum === item.portNum) || {
            hostIpAddress: '',
            hostMacAddress: '',
            hostName: '',
            remotePortId: '',
          }
          return { ...item, ...neighbor }
        })
      }
    },
    queryPortList(params, config = { loading: true }) {
      if (this.loadingPortList) return
      this.loadingPortList = true
      return api.networks
        .queryPortList(params, config)
        .then((data) => {
          if (data.resp.respCode === 0) {
            const { switchPortConfig } = data
            this.setPortList(switchPortConfig)
            // let initPortList = switchPortConfig.unit
            //   .flatMap(item => item.slot)
            //   .flatMap(item => (item.fanout ? [...item.port, ...item.fanout] : item.port))
            //   .map(item => {
            //     const neighbor = this.neighborList.find(obj => obj.portNum === item.portNum) || {
            //       hostIpAddress: '',
            //       hostMacAddress: '',
            //       hostName: '',
            //       remotePortId: ''
            //     };
            //     return { ...item, ...neighbor };
            //   });

            // this.portList = initPortList;
            // this.initNetwork = switchPortConfig.unit;
          }
          return data
        })
        .catch((error) => {
          throw error
        })
        .finally(() => {
          this.loadingPortList = false
        })
    },
    setPortList(switchPortConfig) {
      let initPortList = switchPortConfig.unit
        .flatMap((item) => item.slot)
        .flatMap((item) => (item.fanout ? [...item.port, ...item.fanout] : item.port))
        .map((item) => {
          const neighbor = this.neighborList.find((obj) => obj.portNum === item.portNum) || {
            hostIpAddress: '',
            hostMacAddress: '',
            hostName: '',
            remotePortId: '',
          }
          return { ...item, ...neighbor }
        })
      this.portList = initPortList
      this.initNetwork = switchPortConfig.unit
    },
    deletePortMode(params) {
      return api.networks.deletePortMode(params)
    },

    deleteNetworks(params) {
      return api.networks.deleteNetworks(params)
    },

    deleteProfile(params) {
      return api.networks.deleteProfile(params)
    },

    queryProfileTemplatesList() {
      return api.networks
        .queryProfileTemplatesList()
        .then((data) => {
          if (data.resp.respCode === 0) {
            this.setProfileTemplate(data.profile)
          }
          return data
        })
        .catch((error) => {
          throw error
        })
    },
    setProfileTemplate(response) {
      const list = response.map((item) => ({
        ...item,
        sortName: PROFILETYPE_FILTER(item.name),
      }))
      const sortedList = [...list].sort((a, b) => a.sortName.localeCompare(b.sortName))
      this.templateList = sortedList
        .filter((item) => item.custom !== false)
        .concat(sortedList.filter((item) => item.custom === false))
    },

    addProfileTemplates(params) {
      return api.networks.addProfileTemplates(params)
    },

    updateProfileTemplates(params) {
      return api.networks.updateProfileTemplates(params)
    },

    deleteProfileTemplates(params) {
      return api.networks.deleteProfileTemplates(params)
    },

    autoTrunk(params) {
      return api.networks.autoTrunk(params)
    },
    setAutoMode(data) {
      this.autoMode = data.autoMode
      this.autoModeUpdated = true
    },
    autoLag(params) {
      return api.networks.autoLag(params)
    },

    queryAutoTrunk() {
      return api.networks.queryAutoTrunk().then((data) => {
        if (data.resp.respCode === 0) {
          this.setAutoMode(data.switchConfigAutoTrunk)
          return data
        }
      })
    },

    queryAutoLag() {
      return api.networks
        .queryAutoLag()
        .then((json) => {
          if (json.resp.respCode === 0) {
            this.setAutoLagList(json.switchConfigAutoLag)
          }
        })
        .catch((err) => {
          console.error('queryAutoLag error:', err)
        })
    },
    setAutoLagList(switchConfigAutoLag) {
      this.autoLagList = switchConfigAutoLag
    },

    updateShure() {
      return api.networks.updateShure()
    },

    deleteShure() {
      return api.networks.deleteShure()
    },

    queryPtpSwitchInfo() {
      return api.networks.queryPtpSwitchInfo().then((data) => {
        if (data.resp.respCode == 0) {
          this.setSwitchPtpCfg(data.switchPtpCfg)
          return data
        }
      })
    },
    setSwitchPtpCfg(data) {
      this.switchPtpCfg = data
      this.switchPtpCfgUpdated = true
    },
    updatePtpSwitchInfo(params) {
      return api.networks.updatePtpSwitchInfo(params)
    },

    updateQuerierInfo(params) {
      return api.networks.updateQuerierInfo(params)
    },

    queryQuerierInfo(params) {
      return api.networks.queryQuerierInfo(params)
    },

    queryQtpInfo(params) {
      return api.networks.queryQtpInfo(params)
    },

    updateQtpInfo(params) {
      return api.networks.updateQtpInfo(params)
    },

    updateHarmanInfo(params) {
      return api.networks.updateHarmanInfo(params)
    },

    updateVisionaryInfo(params) {
      return api.networks.updateVisionaryInfo(params)
    },

    updateManualTrunkInfo(params) {
      return api.networks.updateManualTrunkInfo(params)
    },

    queryManualTrunkInfo(params) {
      return api.networks
        .queryManualTrunkInfo(params)
        .then((json) => {
          if (json.resp.respCode === 0) {
            this.setSwitchConfigManualTrunk(json.switchConfigManualTrunk)
          }
        })
        .catch((err) => {
          console.error('queryManualTrunkInfo error:', err)
        })
    },

    updateVlanDhcpInfo({ params, success }) {
      return api.networks.updateVlanDhcpInfo(params).then((json) => {
        if (json.resp.respCode === 0) {
          success(json)
        }
      })
    },
    addVlanInfoNew(params) {
      return api.networks.addVlanInfoNew(params)
    },
    queryVlanDhcpInfoByVlanId(params) {
      return api.networks.queryVlanDhcpInfoByVlanId(params)
    },
    setSwitchConfigManualTrunk(data) {
      this.switchConfigManualTrunk = data
    },
    setInitNetwork(data) {
      // this.initNetwork = data;
    },
  },
})

